export enum DoctorFeatureEnum {
  ADMIN_PRIVILEGES = "admin_privileges",
  TYPIST_LOGIN = "typist_login",
  ASSIGN_CASE = "assign_case",
  REPORT_EDIT_FULL_SCREEN_DEFAULT = "report_edit_full_screen_default",
  REPORT_LOCK = "report_lock",
  AUTO_SAVE = "auto_save",
  FORCE_UNLOCK = "force_unlock_report",
  NO_REPORT_EDIT = "no_report_edit",
}